/**
 * Utility to export data to CSV
 */
export function exportToCSV<T extends Record<string, unknown>>(
  data: T[], 
  filename: string,
  columns: { key: keyof T, header: string }[]
) {
  try {
    // Create CSV header row
    const header = columns.map(col => col.header).join(',');
    
    // Create CSV rows
    const rows = data.map(item => {
      return columns.map(col => {
        // Get value for the current column from the data item
        const value = item[col.key];
        
        // Format the value properly for CSV
        if (value === null || value === undefined) {
          return '';
        } else if (typeof value === 'string') {
          // Escape quotes and wrap with quotes if it contains commas, quotes, or newlines
          const escaped = value.replace(/"/g, '""');
          return /[",\n\r]/.test(value) ? `"${escaped}"` : escaped;
        } else if (typeof value === 'object' && value && 'toISOString' in value && typeof value.toISOString === 'function') {
          // Check if it's a Date object by looking for toISOString method
          return value.toISOString();
        } else if (typeof value === 'object') {
          // For objects, convert to JSON string and escape
          const escaped = JSON.stringify(value).replace(/"/g, '""');
          return `"${escaped}"`;
        } else {
          return String(value);
        }
      }).join(',');
    }).join('\n');
    
    // Combine header and rows
    const csvContent = `${header}\n${rows}`;
    
    // Create a blob and download link
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    
    // Create a temporary link element and trigger download
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', `${filename}_${new Date().toISOString().slice(0, 10)}.csv`);
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    
    // Clean up
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error('Error exporting to CSV:', error);
    return false;
  }
} 